export default __webpack_public_path__ + "static/media/Samarth Tandon.3fe6aab1.jpg";